import { EdgenModalCreateAble } from "../../EdgenModal";
import { AnalyzePortfolioModalContent } from "./AnalyzePortfolioModalContent";
import { AnalyzePortfolioModalCallableParams } from "./types";

export const AnalyzePortfolioModalCallable = async (
  params?: AnalyzePortfolioModalCallableParams,
): Promise<boolean> => {
  const { onClose, type = "DAILY_REPORT" } = params || {};
  let instanceRef: Promise<boolean> | null = null;
  const handleClose = () => {
    if (!instanceRef) {
      return;
    }
    onClose?.();
    EdgenModalCreateAble.end(instanceRef, false);
  };

  instanceRef = EdgenModalCreateAble.call({
    className:
      "[--main-height:calc(100dvh-54px)] md:[--main-height:752px] md:[--main-width:800px]",
    title: null,
    wrapperStyle: {
      height: "var(--main-height)",
      width: "var(--main-width, 100%)",
    },
    contentStyle: {
      height: "var(--main-height)",
      width: "var(--main-width, 100%)",
    },
    containerStyle: {
      height: "100%",
      overflow: "hidden",
      width: "100%",
      maxWidth: "100%",
    },
    bodyStyle: {
      height: "100%",
      overflow: "hidden",
    },
    containerClassName:
      "p-4 rounded-2xl md:p-0 md:rounded-none bg-background_solid_secondary h-full !max-h-full",
    children: (
      <AnalyzePortfolioModalContent onClose={handleClose} type={type} />
    ),
  });

  return instanceRef;
};
